import type { DocMigration } from "../docMigration";

/**
 * `ROOM_LABELS` became a section view category, generated by the `ROOM_LABELS` section geometry
 * generator. Section labels used to be rendered by a separate pathway that was not category
 * controlled, so existing section view templates carry no `ROOM_LABELS` entry and would silently
 * lose their labels. Insert it where a freshly defaulted section template would place it -- ahead of
 * `ROOF`, matching `sheetGeometryCategoryExposedOnUIToViewType` declaration order -- so migrated
 * docs render the same order as new ones.
 */
const migration: DocMigration = {
  id: "20260814_add_room_labels_to_section_view_templates",
  description: "Add ROOM_LABELS to existing section view template categories",
  apply(json: any) {
    for (const id in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[id];
      if (viewTemplate.viewType !== "SECTION_VIEW" || !Array.isArray(viewTemplate.categories)) {
        continue;
      }
      if (viewTemplate.categories.includes("ROOM_LABELS")) {
        continue;
      }

      const roofIndex = viewTemplate.categories.indexOf("ROOF");
      if (roofIndex === -1) {
        viewTemplate.categories.push("ROOM_LABELS");
      } else {
        viewTemplate.categories.splice(roofIndex, 0, "ROOM_LABELS");
      }
    }
    return json;
  },
};

export default migration;
